var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17 0.75C14.0573 0.75 11.3229 1.49219 8.79688 2.97656C6.34896 4.40885 4.40885 6.34896 2.97656 8.79688C1.49219 11.3229 0.75 14.0573 0.75 17C0.75 19.9427 1.49219 22.6771 2.97656 25.2031C4.40885 27.651 6.34896 29.5911 8.79688 31.0234C11.3229 32.5078 14.0573 33.25 17 33.25C19.9427 33.25 22.6771 32.5078 25.2031 31.0234C27.651 29.5911 29.5911 27.651 31.0234 25.2031C32.5078 22.6771 33.25 19.9427 33.25 17C33.25 14.0573 32.5078 11.3229 31.0234 8.79688C29.5911 6.34896 27.651 4.40885 25.2031 2.97656C22.6771 1.49219 19.9427 0.75 17 0.75ZM17 3.25C19.5 3.25 21.8177 3.875 23.9531 5.125C26.0104 6.34896 27.651 7.98958 28.875 10.0469C30.125 12.1823 30.75 14.5 30.75 17C30.75 19.5 30.125 21.8177 28.875 23.9531C27.651 26.0104 26.0104 27.651 23.9531 28.875C21.8177 30.125 19.5 30.75 17 30.75C14.5 30.75 12.1823 30.125 10.0469 28.875C7.98958 27.651 6.34896 26.0104 5.125 23.9531C3.875 21.8177 3.25 19.5 3.25 17C3.25 14.5 3.875 12.1823 5.125 10.0469C6.34896 7.98958 7.98958 6.34896 10.0469 5.125C12.1823 3.875 14.5 3.25 17 3.25ZM16.1016 8.99219L8.09375 17L16.1016 25.0078L17.8984 23.25L12.8984 18.25H25.75V15.75H12.8984L17.8984 10.75L16.1016 8.99219Z",
    fill: "#778CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.1ff7759b911a5ee6fa83f9fcc8a2ded5.svg";
export { ForwardRef as ReactComponent };